<template>
  <path
    d="M13 19.0002V7.83022L17.88 12.7102C18.27 13.1002 18.91 13.1002 19.3 12.7102C19.69 12.3202 19.69 11.6902 19.3 11.3002L12.71 4.71022C12.32 4.32022 11.69 4.32022 11.3 4.71022L4.7 11.2902C4.31 11.6802 4.31 12.3102 4.7 12.7002C5.09 13.0902 5.72 13.0902 6.11 12.7002L11 7.83022V19.0002C11 19.5502 11.45 20.0002 12 20.0002C12.55 20.0002 13 19.5502 13 19.0002Z"
  />
</template>
